import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Accreditations from "./tabs/Accreditations";
import { Wrapper } from "../styled";

const accreditationTabs = [
  {
    title: "Аккредитация",
    component: <Accreditations/>,
  }
];

const Accreditation: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {accreditationTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {accreditationTabs[tab].component}
    </Wrapper>
  );
};

export default Accreditation;